import {
    Box,
    Flex,
    HStack,
    Input,
    Text,
    Textarea,
    VStack,
    Spinner,
    Button,
    Image,
  } from '@chakra-ui/react';
  import React, { useEffect, useState } from 'react';
  import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
  import BrandButton from '../../../components/brandButton/BrandButton';
  import { CustomToast } from '../../../components/toast/CustomToast';
  import { useData } from '../../../data';
  import { mutateFunction, useMutation } from '../../../libs/apis';
  import IsDesktop from '../../../utils/IsDesktop';
  import { useSelector } from 'react-redux';
  
  const AddNews = ({ onToggle, refetch }) => {
    const isDesktop = IsDesktop();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        url: ""
    });
    const { mutate, isLoading: mutateIsLoading } = useMutation(mutateFunction);
    const loggedInUserId = useSelector((state) => state?.user?.userInfo?.id);
  
    const { addToast } = CustomToast();

    const handleChange = (e) => {
        setFormData((prev) => ({
          ...prev,
          [e.target.name]: e.target.value
        }));
    };

    const addNews = () => {
     
        let  data = {}
        for(let key of Object.keys(formData)){
            data[key] = formData[key].trim()
        }
      mutate(
        { key: `news`, method: 'post', data },
        {
          onSuccess(res) {
            addToast(res);
            refetch();
            onToggle();
          },
          onError(res) {
            addToast(
              {
                message: res?.response?.data?.message || 'Please fill all fields',
              },
              'error',
            );
          },
        },
      );
    };

    return (
      <VStack alignItems="flex-start">
        <Flex justifyContent="flex-start" alignItems="center" my={4} mx={4}>
          <Flex
            cursor="pointer"
            onClick={onToggle}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Box mr={2}>
              <HiOutlineArrowNarrowLeft size="35px" />
            </Box>
            <Box>
              <Text fontWeight={600}>Back</Text>
            </Box>
          </Flex>
        </Flex>
        <HStack className="p-4" h="500px" w="100%" alignItems="flex-start" m={4}>
          <VStack w="60%" alignItems="flex-start">
            <Flex flexDir="column" w="100%" key="name">
              <Text fontSize="14px" mb={2}>
                Title
              </Text>
              <Input
                borderWidth="1px"
                borderColor="brand.primary"
                borderRadius="5px"
                focusBorderColor="#"
                variant="outline"
                placeholder="Title"
                name="title"
                type="text"
                w="100%"
                h="50px"
                onChange={(e) => handleChange(e)}
              />
            </Flex>
            <Flex flexDir="column" w="100%" key="name">
              <Text fontSize="14px" mb={2}>
                Url
              </Text>
              <Input
                borderWidth="1px"
                borderColor="brand.primary"
                borderRadius="5px"
                focusBorderColor="#"
                variant="outline"
                placeholder="Url"
                name="url"
                type="text"
                w="100%"
                h="50px"
                onChange={(e) => handleChange(e)}
              />
            </Flex>
            <Flex flexDir="column" w="100%" h="100%" key="details" mx={4}>
              <Text fontSize="14px" mb={2}>
                Brief Details
              </Text>
              <Textarea
                borderWidth="1px"
                borderColor="brand.primary"
                borderRadius="5px"
                focusBorderColor="#"
                variant="outline"
                placeholder="Url Description"
                name="description"
                type="text"
                h="100%"
                w="100%"
                maxLength={100}
                onChange={(e) => handleChange(e)}
              />
            </Flex>

  
            <BrandButton
              isLoading={mutateIsLoading}
              text="Add News"
              w="120px"
              colorScheme="blue"
              onClick={() => addNews()}
            />
          </VStack>
        </HStack>
      </VStack>
    );
  };
  export default AddNews;
  